<template>
  <!-- flex 纵向三段:筛选卡(自适应) / 表格区(占满剩余) —— 高度不再靠 JS 估算,布局由 CSS 保证 -->
  <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
    <!-- 商城订单页：订单记录 / 退款申请 双视图 -->
    <div style="flex-shrink: 0; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar">
          <el-radio-group v-model="viewMode" size="mini" @change="handleViewChange">
            <el-radio-button label="order">订单记录</el-radio-button>
            <el-radio-button label="apply">退款申请</el-radio-button>
          </el-radio-group>
          <el-select size="mini" v-model="currentForm.asId" filterable clearable placeholder="商户名称"
            style="width: 180px">
            <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
              :value="item.asId"></el-option>
          </el-select>
          <el-input v-model="currentForm.asorPhone" style="width: 160px" size="mini" placeholder="手机号"
            clearable></el-input>
          <template v-if="viewMode === 'order'">
            <el-select size="mini" v-model="formDatas.asorStatus" clearable placeholder="订单状态"
              style="width: 130px" @change="partserch">
              <el-option label="待匹配" :value="1" key="s1"></el-option>
              <el-option label="已匹配" :value="2" key="s2"></el-option>
              <el-option label="无匹配" :value="3" key="s3"></el-option>
            </el-select>
            <el-select size="mini" v-model="formDatas.asorBillStatus" clearable placeholder="分账状态"
              style="width: 130px" @change="partserch">
              <el-option label="待分账" :value="1" key="b1"></el-option>
              <el-option label="已分账" :value="2" key="b2"></el-option>
              <el-option label="已退款" :value="3" key="b3"></el-option>
            </el-select>
            <el-input v-model="formDatas.mrchOrderNo" style="width: 180px" size="mini"
              placeholder="易宝通商户订单号" clearable></el-input>
            <!-- 内部商城订单号(模糊筛选,内部商城配套) -->
            <el-input v-model="formDatas.asorOrderNo" style="width: 180px" size="mini"
              placeholder="内部商城订单号" clearable></el-input>
            <el-date-picker v-model="asorTimeStart" type="date" value-format="yyyy-MM-dd" placeholder="订单时间-开始"
              style="width: 150px" size="mini" clearable></el-date-picker>
            <el-date-picker v-model="asorTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="订单时间-结束"
              style="width: 150px" size="mini" clearable></el-date-picker>
          </template>
          <template v-else>
            <el-select size="mini" v-model="applyFormDatas.asoraStatus" clearable placeholder="审核状态"
              style="width: 130px" @change="partserch">
              <el-option label="待审核" :value="1" key="a1"></el-option>
              <el-option label="已通过" :value="2" key="a2"></el-option>
              <el-option label="已拒绝" :value="3" key="a3"></el-option>
            </el-select>
            <el-select size="mini" v-model="applyFormDatas.asoraFrom" clearable placeholder="来源"
              style="width: 150px" @change="partserch">
              <el-option label="商户申请" :value="1" key="f1"></el-option>
              <el-option label="管理员直接退款" :value="2" key="f2"></el-option>
            </el-select>
            <el-select size="mini" v-model="applyFormDatas.asoraRefundStatus" clearable placeholder="退款执行"
              style="width: 130px" @change="partserch">
              <el-option label="未执行" :value="1" key="r1"></el-option>
              <el-option label="成功" :value="2" key="r2"></el-option>
              <el-option label="失败" :value="3" key="r3"></el-option>
            </el-select>
          </template>
          <!-- 按钮组：filter-actions 固定贴容器右下角,查询组件围绕其流动换行 -->
          <div class="filter-actions">
            <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
            <!-- 补录订单记录(仅订单记录视图,内部商城配套) -->
            <el-button v-if="viewMode === 'order'" type="primary" size="mini" icon="el-icon-plus" @click="openAddDialog">补录订单记录</el-button>
            <!-- 导出excel(仅订单记录视图;与列表同筛选,后端游标分批导出) -->
            <el-button v-if="viewMode === 'order'" type="warning" size="mini" icon="el-icon-download"
              :loading="exportLoading" @click="exportExcel">导出Excel</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div class="table-wrap" ref="tableWrap">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="currentForm.currentPage" :page-size="currentForm.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 易宝通支付订单详情弹窗（与YbtPayOrder页一致） -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="800px" append-to-body>
      <div v-if="detailData" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="商户订单号">{{ detailData.mrchOrderNo }}</el-descriptions-item>
          <el-descriptions-item label="交易订单号">{{ detailData.tradeNo }}</el-descriptions-item>
          <el-descriptions-item label="商户号">{{ detailData.merchantNo }}</el-descriptions-item>
          <el-descriptions-item label="用户账号">{{ detailData.userAccount }}</el-descriptions-item>
          <el-descriptions-item label="支付金额">{{ detailData.payAmount ? (detailData.payAmount / 100).toFixed(2) + '元' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="成本价金额">{{ detailData.payCostAmount ? (detailData.payCostAmount / 100).toFixed(2) + '元' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="交易状态">
            <el-tag :type="getTradeStatusType(detailData.tradeStatus)" size="small">{{ getTradeStatusText(detailData.tradeStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="通知状态">
            <el-tag :type="getNotifyStatusType(detailData.notifyStatus)" size="small">{{ getNotifyStatusText(detailData.notifyStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="是否同步">
            <el-tag :type="detailData.ypoSyncEquityfee === 2 ? 'success' : 'info'" size="small">{{ detailData.ypoSyncEquityfee === 2 ? '是' : '否' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="交易日期">{{ detailData.transDate }}</el-descriptions-item>
          <el-descriptions-item label="过期时间">{{ detailData.expireTime }}</el-descriptions-item>
          <el-descriptions-item label="交易时间">{{ detailData.tradeTime }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ detailData.createtime }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{ detailData.updatetime }}</el-descriptions-item>
          <el-descriptions-item label="回调地址" :span="2">{{ detailData.backUrl }}</el-descriptions-item>
          <el-descriptions-item label="通知地址" :span="2">{{ detailData.notifyUrl }}</el-descriptions-item>
        </el-descriptions>

        <div v-if="detailData.productInfoList && detailData.productInfoList.length > 0" style="margin-top: 20px">
          <h4>商品信息</h4>
          <el-table :data="detailData.productInfoList" border size="small">
            <el-table-column prop="itemName" label="商品名称" />
            <el-table-column prop="itemCode" label="商品编码" />
            <el-table-column label="商品销售价">
              <template slot-scope="scope">
                {{ scope.row.salePrice ? (scope.row.salePrice).toFixed(2) + '元' : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="saleNum" label="销售数量" />
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 手动绑定易宝通订单弹窗：无匹配/金额不符时由管理员指定订单，绑定成功即分账 -->
    <el-dialog title="绑定易宝通订单" :visible.sync="bindDialogVisible" width="1000px" append-to-body
      @closed="handleBindClosed">
      <div v-if="bindRecord" style="margin-bottom: 10px; color: #606266; font-size: 13px">
        <span style="margin-right: 20px">订单记录：{{ bindRecord.asorId }}</span>
        <span style="margin-right: 20px">商户：{{ bindRecord.asName || "-" }}</span>
        <span style="margin-right: 20px">录入手机号：{{ bindRecord.asorPhone }}</span>
        <span>录入订单时间：{{ bindRecord.asorTime }}</span>
      </div>
      <div style="margin-bottom: 10px">
        <el-input v-model="bindFormDatas.userAccount" size="mini" style="width: 200px" placeholder="手机号(易宝通用户账号)"
          clearable @keyup.enter.native="searchBindList"></el-input>
        <el-button type="info" size="mini" icon="el-icon-search" style="margin-left: 10px" @click="searchBindList">搜索</el-button>
        <span style="margin-left: 10px; color: #909399; font-size: 12px">默认按录入手机号查询，可改为其他手机号后重新搜索</span>
      </div>
      <el-table :data="bindTableData" border size="small" v-loading="bindLoading" height="380">
        <el-table-column prop="mrchOrderNo" label="商户订单号" width="200" show-overflow-tooltip />
        <el-table-column prop="userAccount" label="用户账号" width="130" />
        <el-table-column label="支付金额" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.payAmount != null ? (scope.row.payAmount / 100).toFixed(2) + "元" : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="tradeTime" label="交易时间" width="160" align="center" />
        <el-table-column label="是否可绑定" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="!scope.row.canBind" :content="scope.row.canBindDes || '该订单不可绑定'" placement="top">
              <el-tag type="danger" size="mini">不可绑定</el-tag>
            </el-tooltip>
            <el-tag v-else type="success" size="mini">可绑定</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled="!scope.row.canBind" @click="handleBindSelect(scope.row)">
              {{ bindSelectedRow && bindSelectedRow.ypoId === scope.row.ypoId ? "已选择" : "选择" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 8px; text-align: right">
        <ve-pagination :total="bindTotalCount" :page-index="bindFormDatas.currentPage"
          :page-size="bindFormDatas.pageSize" :page-size-option="[10, 20, 40, 80]"
          @on-page-number-change="bindPageNumberChange" @on-page-size-change="bindPageSizeChange" />
      </div>
      <span slot="footer" class="dialog-footer"
        style="display: flex; align-items: center; justify-content: space-between">
        <span v-if="bindSelectedRow" style="color: #67C23A; font-size: 13px">
          已选：{{ bindSelectedRow.mrchOrderNo }} /
          {{ bindSelectedRow.payAmount != null ? (bindSelectedRow.payAmount / 100).toFixed(2) : "-" }}元
        </span>
        <span v-else style="color: #909399; font-size: 13px">请选择要绑定的易宝通订单</span>
        <span>
          <el-button @click="bindDialogVisible = false">取消</el-button>
          <el-button type="primary" :disabled="!bindSelectedRow || !bindSelectedRow.canBind"
            :loading="bindConfirmLoading" @click="confirmBind">确认绑定并分账</el-button>
        </span>
      </span>
    </el-dialog>
    <!-- 补录订单记录弹窗(内部商城配套):老方式(商户+手机号+时间)或带内部商城订单号 -->
    <el-dialog title="补录订单记录" :visible.sync="addDialogVisible" width="500px" append-to-body
      @closed="resetAddForm">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="110px" size="small">
        <el-form-item label="商户" prop="asId">
          <el-select v-model="addForm.asId" filterable placeholder="请选择商户" style="width: 100%">
            <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
              :value="item.asId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="asorPhone">
          <el-input v-model="addForm.asorPhone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单时间" prop="asorTime">
          <el-date-picker v-model="addForm.asorTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择订单时间" style="width: 100%" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="内部商城订单号" prop="asorOrderNo">
          <el-input v-model="addForm.asorOrderNo" placeholder="请输入内部商城订单号" clearable></el-input>
          <!-- 带订单号时手机号/时间以商城订单快照为准,防操作员录错 -->
          <div style="color: #909399; font-size: 12px; line-height: 1.5">
            填写内部商城订单号时，手机号/订单时间可空，以商城订单为准
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="confirmAdd">确 定 补 录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAjefShopOrderRecordList, getAjefShopListQuick, getYbtPayOrderDetails, getYbtPayOrderListForBind, bindAjefShopOrderRecord, updateAjefShopOrderRefundDirect, getAjefShopOrderRefundApplyList, updateAjefShopOrderRefundApplyAdopt, updateAjefShopOrderRefundApplyReject, updateAjefShopOrderRefundRightsFundRetry, updateAjefShopOrderRefundCancelDirect, addAjefShopOrderRecordAdmin, exportAjefShopOrderRecordExcel } from "../../api/api";
export default {
  name: "ShopOrder",
  components: {},
  data() {
    return {
      tableLoading: false,
      // 导出excel请求中(按钮loading,防重复点击)
      exportLoading: false,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      // 易宝通支付订单详情弹窗
      dialogVisible: false,
      detailData: null,
      // 手动绑定易宝通订单弹窗
      bindDialogVisible: false,
      bindLoading: false,
      bindConfirmLoading: false,
      // 当前正在绑定的订单记录
      bindRecord: null,
      // 候选易宝通订单
      bindTableData: [],
      bindTotalCount: 0,
      // 选中的候选订单
      bindSelectedRow: null,
      bindFormDatas: {
        userAccount: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 商户下拉数据（getAjefShopListQuick，pageSize:0 全量）
      getAjefShopList_data: [],
      // 订单时间筛选（单独存放，提交时拼接时分秒）
      asorTimeStart: "",
      asorTimeEnd: "",
      // 视图模式:order=订单记录 apply=退款申请
      viewMode: "order",
      // 补录订单记录弹窗(内部商城配套)
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        asId: "",
        asorPhone: "",
        asorTime: "",
        asorOrderNo: "",
      },
      formDatas: {
        asId: "",
        asorPhone: "",
        asorStatus: "",
        asorBillStatus: "",
        mrchOrderNo: "",
        asorOrderNo: "",
        asorTimeStart: "",
        asorTimeEnd: "",
        currentPage: 1,
        pageSize: 10,
      },
      applyFormDatas: {
        asId: "",
        asorPhone: "",
        asoraStatus: "",
        asoraFrom: "",
        asoraRefundStatus: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 补录表单校验:商户必填;手机号/订单时间仅在未填内部商城订单号时必填(带订单号以商城订单为准)
      addFormRules: {
        asId: [{ required: true, message: "请选择商户", trigger: "change" }],
        asorPhone: [{
          validator: (rule, value, callback) => {
            if (!this.addForm.asorOrderNo && !value) {
              callback(new Error("未填内部商城订单号时手机号必填"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        }],
        asorTime: [{
          validator: (rule, value, callback) => {
            if (!this.addForm.asorOrderNo && !value) {
              callback(new Error("未填内部商城订单号时订单时间必填"));
            } else {
              callback();
            }
          },
          trigger: "change",
        }],
      },
      orderColumns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        // {
        //   field: "asorId",
        //   key: "asorId",
        //   title: "订单记录id",
        //   width: 100,
        //   align: "center",
        // },
        {
          field: "asName",
          key: "asName",
          title: "商户名称",
          width: 180,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row }) => row.asName || "-",
        },
        {
          field: "asorPhone",
          key: "asorPhone",
          title: "手机号",
          width: 130,
          align: "center",
        },
        // 来源:内部商城(带商城订单号)/易宝通(带易宝通订单id),后端返回描述(内部商城配套)
        // 修复小f#10:来源列内换行展示内部商城订单号(有值才显示),便于与商户端订单核对,不新增列以免表格过宽
        {
          field: "asorSourceDes",
          key: "asorSourceDes",
          title: "来源",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            const des = row.asorSourceDes || "-";
            if (!row.asorOrderNo) {
              return des;
            }
            return h("div", { style: { lineHeight: "1.5" } }, [
              h("div", des),
              h("div", {
                style: { fontSize: "11px", color: "#909399", wordBreak: "break-all" },
              }, row.asorOrderNo),
            ]);
          },
        },
        {
          field: "asorTime",
          key: "asorTime",
          title: "订单时间",
          width: 170,
          align: "center",
        },
        {
          field: "mrchOrderNo",
          key: "mrchOrderNo",
          title: "易宝通商户订单号",
          width: 200,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            // 有易宝通订单号时展示详情按钮，调YbtPayOrder页同款详情接口
            if (row.mrchOrderNo) {
              return h("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", lineHeight: "1.5" } }, [
                h("div", { style: { wordBreak: "break-all" } }, row.mrchOrderNo),
                h("el-button", {
                  props: { type: "text", size: "mini" },
                  style: { color: "#409EFF", padding: "0" },
                  on: { click: () => this.handleYbtDetail(row) }
                }, "详情"),
              ]);
            }
            return "-";
          },
        },
        {
          field: "asorAmountStr",
          key: "asorAmountStr",
          title: "订单金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorAmountStr != null && row.asorAmountStr !== ""
              ? row.asorAmountStr + "元"
              : "-";
          },
        },
        // 分账金额两口径:参与分账金额=档位基准(120档20元);商铺分账金额=基准按商户票种折算的实得
        // (专票6%不打折,专票3%/专票1%/普票递减),票种非1时两者不同;
        // asorExchangeRatio已不再写入,原"分账比例"列已移除(2026-09-14)
        {
          field: "asorAmountBillStr",
          key: "asorAmountBillStr",
          title: "参与分账金额",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorAmountBillStr != null && row.asorAmountBillStr !== ""
              ? row.asorAmountBillStr + "元"
              : "-";
          },
        },
        {
          field: "asorExchangeShop",
          key: "asorExchangeShop",
          title: "商铺分账金额",
          width: 120,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorExchangeShop != null
              ? (row.asorExchangeShop / 100).toFixed(2) + "元"
              : "-";
          },
        },
        {
          field: "asorStatus",
          key: "asorStatus",
          title: "订单状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = {
              1: { text: "待匹配", type: "warning" },
              2: { text: "已匹配", type: "success" },
              3: { text: "无匹配", type: "info" },
            };
            const status = statusMap[row.asorStatus];
            if (status) {
              // 优先展示后端返回的状态描述
              return h("el-tag", { props: { type: status.type, size: "mini" } },
                row.asorStatusDes || status.text);
            }
            return "-";
          },
        },
        {
          field: "asorBillStatus",
          key: "asorBillStatus",
          title: "分账状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = {
              1: { text: "待分账", type: "warning" },
              2: { text: "已分账", type: "success" },
              3: { text: "已退款", type: "danger" },
            };
            const status = statusMap[row.asorBillStatus];
            if (status) {
              return h("el-tag", { props: { type: status.type, size: "mini" } }, status.text);
            }
            return "-";
          },
        },
        // 分账时间(2026-10-13,财务对账):首次分账成功时间,退款不覆盖
        {
          field: "asorBillTime",
          key: "asorBillTime",
          title: "分账时间",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) =>
            row.asorBillTime != null && row.asorBillTime !== "" ? row.asorBillTime : "-",
        },
        {
          field: "asorUserName",
          key: "asorUserName",
          title: "录入人",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }) => row.asorUserName || "-",
        },
        {
          field: "asorUserBelong",
          key: "asorUserBelong",
          title: "录入人归属",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => row.asorUserBelong || "-",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "录入时间",
          width: 170,
          align: "center",
        },
        {
          field: "asorDes",
          key: "asorDes",
          title: "备注",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) => row.asorDes || "-",
        },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 110,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            // 已分账的记录可退款(管理员直接退款,回退分账金额并联动回退权益金)
            if (row.asorBillStatus === 2) {
              return h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#F56C6C", padding: "0" },
                on: { click: () => this.handleRefundDirect(row) }
              }, "直接退款");
            }
            // 仅"待匹配/无匹配"且未分账的记录可手动绑定易宝通订单
            if (row.asorStatus !== 2 && row.asorBillStatus !== 2) {
              return h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#409EFF", padding: "0" },
                on: { click: () => this.openBindDialog(row) }
              }, "绑定订单");
            }
            return "-";
          },
        },
      ],
      applyColumns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "asName",
          key: "asName",
          title: "商户名称",
          width: 180,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row }) => row.asName || "-",
        },
        { field: "asorPhone", key: "asorPhone", title: "手机号", width: 130, align: "center" },
        { field: "mrchOrderNo", key: "mrchOrderNo", title: "易宝通商户订单号", width: 200, align: "center" },
        {
          field: "asorAmountStr", key: "asorAmountStr", title: "订单金额", width: 100, align: "center",
          renderBodyCell: ({ row }) => row.asorAmountStr ? row.asorAmountStr + "元" : "-",
        },
        {
          field: "asorAmountBillStr", key: "asorAmountBillStr", title: "参与分账金额", width: 110, align: "center",
          renderBodyCell: ({ row }) => row.asorAmountBillStr ? row.asorAmountBillStr + "元" : "-",
        },
        {
          field: "asoraRefundMoneyYuan", key: "asoraRefundMoneyYuan", title: "分账退款金额", width: 110, align: "center",
          renderBodyCell: ({ row }) => row.asoraRefundMoneyYuan ? row.asoraRefundMoneyYuan + "元" : "-",
        },
        {
          field: "asoraRightsFundMoneyYuan", key: "asoraRightsFundMoneyYuan", title: "权益金回退金额", width: 120, align: "center",
          renderBodyCell: ({ row }) => row.asoraRightsFundMoneyYuan ? row.asoraRightsFundMoneyYuan + "元" : "-",
        },
        { field: "asoraFromDes", key: "asoraFromDes", title: "来源", width: 120, align: "center" },
        {
          field: "asoraReason", key: "asoraReason", title: "申请/退款原因", width: 180, align: "center",
          renderBodyCell: ({ row }) => row.asoraReason || "-",
        },
        {
          field: "asoraStatusDes", key: "asoraStatusDes", title: "审核状态", width: 100, align: "center",
          renderBodyCell: ({ row }, h) => {
            const type = row.asoraStatus === 1 ? "warning" : row.asoraStatus === 2 ? "success" : "info";
            return h("el-tag", { props: { type, size: "mini" } }, row.asoraStatusDes || "-");
          },
        },
        {
          field: "asoraRejectReason", key: "asoraRejectReason", title: "拒绝原因", width: 160, align: "center",
          renderBodyCell: ({ row }) => row.asoraRejectReason || "-",
        },
        {
          field: "asoraRefundStatusDes", key: "asoraRefundStatusDes", title: "退款执行", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            const type = row.asoraRefundStatus === 2 ? "success" : row.asoraRefundStatus === 3 ? "danger" : "info";
            return h("el-tag", { props: { type, size: "mini" } }, row.asoraRefundStatusDes || "-");
          },
        },
        {
          field: "asoraRightsFundStatusDes", key: "asoraRightsFundStatusDes", title: "权益金回退", width: 100, align: "center",
          renderBodyCell: ({ row }, h) => {
            const type = row.asoraRightsFundStatus === 2 ? "success" : row.asoraRightsFundStatus === 3 ? "danger" : "info";
            return h("el-tag", { props: { type, size: "mini" } }, row.asoraRightsFundStatusDes || "-");
          },
        },
        {
          field: "asoraBalanceStatusDes", key: "asoraBalanceStatusDes", title: "余额扣减", width: 120, align: "center",
          renderBodyCell: ({ row }) => row.asoraBalanceStatusDes || "-",
        },
        {
          field: "asoraDes", key: "asoraDes", title: "结果描述", width: 200, align: "center",
          renderBodyCell: ({ row }) => {
            const des = [row.asoraRefundDes, row.asoraRightsFundDes].filter(v => v).join(" / ");
            return des || "-";
          },
        },
        { field: "createtime", key: "createtime", title: "申请时间", width: 170, align: "center" },
        { field: "asoraCheckTime", key: "asoraCheckTime", title: "审核时间", width: 170, align: "center" },
        {
          field: "asoraCancelInfo", key: "asoraCancelInfo", title: "撤销(人/时间)", width: 180, align: "center",
          renderBodyCell: ({ row }) => row.asoraCancelTime ? (row.asoraCancelUserName || "-") + " " + row.asoraCancelTime : "-",
        },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 170,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            const buttons = [];
            if (row.asoraStatus === 1) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#67C23A", padding: "0", marginRight: "8px" },
                on: { click: () => this.handleApplyAdopt(row) }
              }, "通过"));
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#F56C6C", padding: "0" },
                on: { click: () => this.handleApplyReject(row) }
              }, "拒绝"));
            }
            if (row.asoraRefundStatus === 2 && row.asoraRightsFundStatus === 3) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#E6A23C", padding: "0", marginRight: "8px" },
                on: { click: () => this.handleRightsRetry(row) }
              }, "权益金重试"));
            }
            // 撤销退款(2026-10-01):已执行退款且权益金未回退成功可撤,订单恢复已分账并还原商户账户
            if (row.asoraStatus === 2 && row.asoraRefundStatus === 2 && row.asoraRightsFundStatus !== 2) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#409EFF", padding: "0" },
                on: { click: () => this.handleRefundCancel(row) }
              }, "撤销退款"));
            }
            return buttons.length ? h("div", buttons) : "-";
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  computed: {
    // 表格列按视图切换；筛选表单同理(商户/手机号共用引用)
    columns() {
      return this.viewMode === "apply" ? this.applyColumns : this.orderColumns;
    },
    currentForm() {
      return this.viewMode === "apply" ? this.applyFormDatas : this.formDatas;
    },
  },
  mounted() {
    this.getList();
    // 表格高度自适应：布局由 flex 保证(table-wrap 占满剩余空间),JS 只实测容器高度喂给 ve-table。
    // ResizeObserver 覆盖窗口缩放/筛选卡换行数变化等一切尺寸来源,不再用任何估算常数
    this.tableResizeObserver = new ResizeObserver(() => {
      const wrap = this.$refs.tableWrap;
      if (!wrap) {
        return;
      }
      const h = wrap.clientHeight - 4; // ve-table 边框余量
      if (h > 200 && h !== this.tableHight) {
        this.tableHight = h;
      }
    });
    if (this.$refs.tableWrap) {
      this.tableResizeObserver.observe(this.$refs.tableWrap);
    }
    // 加载商户下拉（pageSize:0 表示全量，与发票管理页口径一致）
    getAjefShopListQuick({ pageSize: 0 }).then((res) => {
      this.getAjefShopList_data = res.data || [];
    });
  },
  destroyed() {
    if (this.tableResizeObserver) {
      this.tableResizeObserver.disconnect();
    }
  },
  methods: {
    // 打开补录弹窗(内部商城配套):老方式或带内部商城订单号
    openAddDialog() {
      this.addDialogVisible = true;
    },
    // 弹窗关闭后重置表单与校验状态
    resetAddForm() {
      this.addForm = {
        asId: "",
        asorPhone: "",
        asorTime: "",
        asorOrderNo: "",
      };
      this.addLoading = false;
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate();
      });
    },
    // 确认补录:校验通过后调后端,分账由定时任务匹配
    confirmAdd() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.addLoading = true;
        addAjefShopOrderRecordAdmin({
          asId: this.addForm.asId,
          asorPhone: this.addForm.asorPhone,
          asorTime: this.addForm.asorTime,
          asorOrderNo: this.addForm.asorOrderNo,
        }).then((res) => {
          this.addLoading = false;
          // 失败时拦截器已弹提示并返回undefined
          if (!res) {
            return;
          }
          this.$message.success("补录成功");
          this.addDialogVisible = false;
          this.getList();
        }).catch(() => {
          this.addLoading = false;
        });
      });
    },
    // 退款提示语(直接退款/审核通过共用):易宝通订单提醒支付部分去易宝通侧退;
    // 内部商城订单已发货/已完成提醒协调退货(2026-10-01)
    refundConfirmTips(row) {
      const tips = [];
      if (row.ypoId && !row.asorOrderNo) {
        tips.push("该订单为易宝通订单:此处将退商户分账金额并回退权益金,易宝通支付部分需到易宝通侧退款");
      }
      if (row.asorOrderNo && row.amoStatus >= 2) {
        const express = [row.amoExpressCompanyName, row.amoExpressNo].filter(v => v).join(" ");
        tips.push("该商城订单" + (row.amoStatus === 3 ? "已完成" : "已发货")
          + (express ? "(" + express + ")" : "") + ",退款后请与供货商协调退货");
      }
      return tips.length ? tips.join("。") + "。" : "";
    },
    // 直接退款:输入原因后调接口,回退分账金额并联动回退用户权益金
    handleRefundDirect(row) {
      this.$prompt(this.refundConfirmTips(row) + "退款后回退商铺分账金额并联动回退用户权益金,请确认", "直接退款", {
        confirmButtonText: "确定退款",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "请输入退款原因(必填),如:易宝通订单已退款",
        inputValidator: (v) => !!(v && v.trim()) || "退款原因不能为空",
      }).then(({ value }) => {
        updateAjefShopOrderRefundDirect({ asorId: row.asorId, asoraReason: value.trim() }).then((res) => {
          if (!res) return;
          this.$message.success("退款完成");
          this.getList();
        });
      }).catch(() => { });
    },
    // 打开绑定弹窗：默认按录入手机号查候选易宝通订单
    openBindDialog(row) {
      this.bindRecord = row;
      this.bindSelectedRow = null;
      this.bindTableData = [];
      this.bindTotalCount = 0;
      this.bindFormDatas.userAccount = row.asorPhone || "";
      this.bindFormDatas.currentPage = 1;
      this.bindDialogVisible = true;
      this.getBindList();
    },
    // 候选易宝通订单列表(交易成功、未退款，后端标记每条是否可绑定)
    getBindList() {
      if (!this.bindRecord) {
        return;
      }
      this.bindLoading = true;
      getYbtPayOrderListForBind({
        asorId: this.bindRecord.asorId,
        userAccount: this.bindFormDatas.userAccount,
        currentPage: this.bindFormDatas.currentPage,
        pageSize: this.bindFormDatas.pageSize,
      }).then((res) => {
        this.bindLoading = false;
        // 失败时拦截器已弹提示并返回undefined
        if (!res) {
          return;
        }
        this.bindTableData = res.data || [];
        this.bindTotalCount = res.total || 0;
      }).catch(() => {
        this.bindLoading = false;
      });
    },
    searchBindList() {
      this.bindFormDatas.currentPage = 1;
      this.getBindList();
    },
    bindPageNumberChange(pageIndex) {
      this.bindFormDatas.currentPage = pageIndex;
      this.getBindList();
    },
    bindPageSizeChange(pageSize) {
      this.bindFormDatas.pageSize = pageSize;
      this.getBindList();
    },
    handleBindSelect(row) {
      this.bindSelectedRow = row;
    },
    handleBindClosed() {
      this.bindSelectedRow = null;
      this.bindTableData = [];
      this.bindTotalCount = 0;
    },
    // 确认绑定：后端校验金额/票种/占用后绑定并立即分账
    confirmBind() {
      if (!this.bindSelectedRow) {
        this.$message.warning("请先选择要绑定的易宝通订单");
        return;
      }
      if (!this.bindSelectedRow.canBind) {
        this.$message.warning(this.bindSelectedRow.canBindDes || "该订单不可绑定");
        return;
      }
      this.$confirm(
        "确认将该易宝通订单绑定到当前订单记录？绑定成功后将立即分账。",
        "提示",
        { type: "warning" }
      ).then(() => {
        this.bindConfirmLoading = true;
        bindAjefShopOrderRecord({
          asorId: this.bindRecord.asorId,
          ypoId: this.bindSelectedRow.ypoId,
        }).then((res) => {
          this.bindConfirmLoading = false;
          if (!res) {
            // 校验不通过，拦截器已弹出具体原因
            return;
          }
          this.$message.success(res.data || "操作成功");
          this.bindDialogVisible = false;
          this.getList();
        }).catch(() => {
          this.bindConfirmLoading = false;
        });
      }).catch(() => { });
    },
    // 列表:按视图调不同接口
    getList() {
      this.tableLoading = true;
      const req = this.viewMode === "apply"
        ? getAjefShopOrderRefundApplyList(this.applyFormDatas)
        : getAjefShopOrderRecordList(this.formDatas);
      req.then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 视图切换:重置页码后拉对应列表
    handleViewChange() {
      this.formDatas.currentPage = 1;
      this.applyFormDatas.currentPage = 1;
      this.getList();
    },
    partserch() {
      // 拼接时间范围：开始补 00:00:00，结束补 23:59:59
      this.formDatas.asorTimeStart = this.asorTimeStart
        ? this.asorTimeStart + " 00:00:00"
        : "";
      this.formDatas.asorTimeEnd = this.asorTimeEnd
        ? this.asorTimeEnd + " 23:59:59"
        : "";
      this.currentForm.currentPage = 1;
      this.getList();
    },
    // 导出excel(与列表同筛选;文件流走裸axios,需前端转blob下载)
    exportExcel() {
      // 与搜索同口径:先把日期选择器值拼接成完整时间串,防止改了日期未点搜索直接导出
      this.formDatas.asorTimeStart = this.asorTimeStart
        ? this.asorTimeStart + " 00:00:00"
        : "";
      this.formDatas.asorTimeEnd = this.asorTimeEnd
        ? this.asorTimeEnd + " 23:59:59"
        : "";
      this.exportLoading = true;
      // 只传导出接口声明的筛选参数(剔除分页字段)
      const params = {
        asId: this.formDatas.asId,
        asorPhone: this.formDatas.asorPhone,
        asorStatus: this.formDatas.asorStatus,
        asorBillStatus: this.formDatas.asorBillStatus,
        mrchOrderNo: this.formDatas.mrchOrderNo,
        asorOrderNo: this.formDatas.asorOrderNo,
        asorTimeStart: this.formDatas.asorTimeStart,
        asorTimeEnd: this.formDatas.asorTimeEnd,
      };
      exportAjefShopOrderRecordExcel(params).then((res) => {
        this.exportLoading = false;
        if (!res || !res.data) {
          this.$message.error("导出失败");
          return;
        }
        const buf = res.data;
        // responseType=arraybuffer 时后端业务错误(如登录失效)返回的 JSON 也会进 then，
        // 以 xlsx 魔数（PK=0x50 0x4B，zip 头）判别：非 PK 按文本解析取 msg 提示，不下载坏文件
        const head = new Uint8Array(buf.slice(0, 2));
        if (!(head[0] === 0x50 && head[1] === 0x4b)) {
          let msg = "导出失败";
          try {
            const json = JSON.parse(new TextDecoder("utf-8").decode(buf));
            if (json && json.msg) {
              msg = json.msg;
            }
          } catch (e) {
            // 响应体非 JSON（如网关 HTML 错误页）时保持默认提示
          }
          this.$message.error(msg);
          return;
        }
        const blob = new Blob([buf], { type: "application/vnd.ms-excel" });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", "商户订单记录.xlsx");
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.$message.success("导出成功");
      }).catch(() => {
        this.exportLoading = false;
        this.$message.error("导出失败");
      });
    },
    pageNumberChange(pageIndex) {
      this.currentForm.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.currentForm.pageSize = pageSize;
      this.getList();
    },
    // 退款申请-审核通过(通过即执行退款:回退分账金额+联动回退权益金)
    handleApplyAdopt(row) {
      this.$confirm(
        this.refundConfirmTips(row) + "确认通过该退款申请？通过后将回退商铺分账金额并联动回退用户权益金。",
        "提示",
        { type: "warning" }
      ).then(() => {
        updateAjefShopOrderRefundApplyAdopt({ asoraId: row.asoraId }).then((res) => {
          if (!res) return;
          this.$message.success("审核通过并退款完成");
          this.getList();
        });
      }).catch(() => { });
    },
    // 撤销退款(用户决定不退了):订单恢复已分账,商户账户按退款口径还原,不动权益金(原退款未回退成功)
    handleRefundCancel(row) {
      this.$confirm(
        "确认撤销该退款?撤销后订单恢复为已分账,商户分账金额按原退款口径还原(权益金未回退成功的不作处理)。",
        "撤销退款",
        { type: "warning" }
      ).then(() => {
        updateAjefShopOrderRefundCancelDirect({ asoraId: row.asoraId }).then((res) => {
          if (!res) return;
          this.$message.success(res.data || "撤销成功");
          this.getList();
        });
      }).catch(() => { });
    },
    // 退款申请-审核拒绝(必填拒绝原因)
    handleApplyReject(row) {
      this.$prompt("请输入拒绝原因(必填)", "拒绝退款申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputValidator: (v) => !!(v && v.trim()) || "拒绝原因不能为空",
      }).then(({ value }) => {
        updateAjefShopOrderRefundApplyReject({ asoraId: row.asoraId, asoraRejectReason: value.trim() }).then((res) => {
          if (!res) return;
          this.$message.success("已拒绝");
          this.getList();
        });
      }).catch(() => { });
    },
    // 退款成功但权益金回退失败的,单独补打远端回退
    handleRightsRetry(row) {
      updateAjefShopOrderRefundRightsFundRetry({ asoraId: row.asoraId }).then((res) => {
        if (!res) return;
        this.$message.success("权益金回退成功");
        this.getList();
      });
    },
    // 易宝通支付订单详情（接口与YbtPayOrder页一致，按ypoId查询）
    handleYbtDetail(row) {
      getYbtPayOrderDetails({ ypoId: row.ypoId }).then((res) => {
        this.detailData = res.data;
        this.dialogVisible = true;
      }).catch(() => {
        this.$message.error('获取详情失败');
      });
    },
    getTradeStatusText(status) {
      const map = { 0: '待支付', 1: '成功', 2: '失败', 3: '已过期' };
      return map[status] || '-';
    },
    getTradeStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' };
      return map[status] || 'info';
    },
    getNotifyStatusText(status) {
      const map = { 1: '待通知', 2: '已通知', 3: '通知失败' };
      return map[status] || '-';
    },
    getNotifyStatusType(status) {
      const map = { 1: 'warning', 2: 'success', 3: 'danger' };
      return map[status] || 'info';
    },
  },
};
</script>

<style scoped>
/* ===== flex 高度链：筛选卡(shrink 0) -> tablemain(flex 1) -> tablecss -> table-wrap(flex 1) -> ve-table =====
   每层 min-height:0 允许收缩,ve-table 的 max-height 由 ResizeObserver 实测 table-wrap 喂入,
   保证表格+分页正好占满视口剩余空间:数据多时表格内滚,数据少时容器贴内容,无空白无溢出 */
.tablemain {
  margin: 0 auto;
  flex: 1;
  min-height: 0;
  height: auto;           /* 覆盖全局 height:90% 定高 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tablecss {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.table-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.table-pagination {
  flex-shrink: 0;
  margin-top: 8px;
  margin-bottom: 4px;
}
</style>
